Vendd.Scripts.load(function () {
    "use strict";

    var $form = $('.x-request-offer-quote-form'), form, formData, wishlistModel, userData, isAuthenticated = false;

    if ($form.length < 1) return;

    form = $form.get(0);

    formData = {
        companyName:  $('input[name="companyName"]').val() || "",
        occupation: $('input[name="occupation"]').val() || "",
        firstName: $('input[name="firstName"]').val() || "",
        lastName: $('input[name="lastName"]').val() || "",
        mobile: $('input[name="mobile"]').val() || "",
        email: $('input[name="email"]').val().trim() || "",
        countryCode: $('select[name="countryCode"]').val() || LhApp.Context.Country,
        address: $('input[name="address"]').val() || "",
        postalCode: $('input[name="postalCode"]').val() || "",
        city: $('input[name="city"]').val() || "",
        area: $('select[name="area"]').val() || ""
    }; 
    
    var wishlistId = $form.data('wishlist-id');
    var widgetCode = $form.data('widget-code');

    var areaAutoCompleteEnabled = $form.data('areaautocomplete').toString().toLowerCase() === 'true';
    var areaLabel = $form.data('arealabel');
    var areas = [];
    var selectedCountry = $('.js-countries-selector option:selected', $form);
    var areasCount = selectedCountry.length > 0 ? selectedCountry.data('areascount') : 0;

    // reCAPTCHA
    var captchaWidgetId, reCaptchaCode;
    var captchaId = "requestOfferQuoteCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once.
        // If a verify attempt has been made with a particular token, it cannot be used again.
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    $('.js-request-offer').on('click', function () {
        if ($form.hasClass('submitted')) {
            $('.js-success', $form).hide();
            $('.js-content', $form).show();
            form.reset();
            $form.removeClass('submitted');
        }
    });

    form.autofillFields = function () {
        userData.CompanyName ? $('input[name="companyName"]').val(userData.CompanyName) : $('input[name="companyName"]').val('');
        userData.Occupation ? $('input[name="occupation"]').val(userData.Occupation) : $('input[name="occupation"]').val('')
        userData.FirstName ? $('input[name="firstName"]').val(userData.FirstName) : $('input[name="firstName"]').val('');
        userData.LastName ? $('input[name="lastName"]').val(userData.LastName) : $('input[name="lastName"]').val('');
        userData.Mobile ? $('input[name="mobile"]').val(userData.Mobile) : $('input[name="mobile"]').val('');
        userData.Email ? $('input[name="email"]').val(userData.Email) : $('input[name="email"]').val('');
        userData.Address ? $('input[name="address"]').val(userData.Address) : $('input[name="address"]').val('');
        userData.PostCode ? $('input[name="postalCode"]').val(userData.PostCode) : $('input[name="postalCode"]').val('');
        userData.City ? $('input[name="city"]').val(userData.City) : $('input[name="city"]').val('');
        userData.CountryCode ? $('select[name="countryCode"]').val(userData.CountryCode) : $('select[name="countryCode"]').val('');
        
        areasCount = $('.js-countries-selector option:selected', $form).length > 0 ? $('.js-countries-selector option:selected', $form).data('areascount') : 0;

        if (areaAutoCompleteEnabled && areasCount > 1) {
            if (userData.CountryCode && userData.PostCode) {
                Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode(userData.CountryCode, userData.PostCode, ""));
            }
        } else {
            form.updatePostalCode(userData.CountryCode);
            userData.Area ? $('input[name="area"]').val(userData.Area) : $('input[name="area"]').val('');
        }

        //update formData with new values
        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"]), select', $form).each(function () {
            formData[$(this).attr('name')] = $(this).val();
        });
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        $form.addClass('submitted');

        var response = envelope.message.data;

        if (response.success) {
            $('.js-error', $form).hide();
            $('.js-generic-error', $form).hide();
            $('.js-content', $form).hide();         
            $('.js-success', $form).show();          
        } else {           
            var errors = envelope.message.data.Errors[0];
            $('.js-error', $form).text(errors).show();
        }

        $form.closest('.fancybox-slide').animate({ scrollTop: 0 }, 300);

        form.resetRecaptcha();
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-generic-error', $form).show();
        $form.closest('.fancybox-slide').animate({ scrollTop: 0 }, 300);

        form.resetRecaptcha();
    };

    form.submit = function () {
        form.loading(true);

        $('input[name]:not([type="checkbox"]):not([type="radio"]), textarea[name]', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.RequestOffer.Messages.SubmitRequestOfferWidget(wishlistId, widgetCode, reCaptchaCode, formData));
    };

    form.getAreasForPostCode = function (envelope) {

        areas = envelope ? envelope.message.data : [];

        var html = Vendd.Handlebars.parse("requestOfferQuoteFormArea_A", areas);
        $('.form-row.area .js-area-wrapper').html(html);
        if (isAuthenticated) {
            areas.forEach(function (area) {
                if (area.Selected) {
                    $('select[name="area"] option[value="' + area.Name + '"]', $form).val(area.Name).attr("selected", "selected");
                }
            });
        }
        //add new validation for area select
        var valOptArea = { area: { required: 'area-required' } };
        rf.removeField("area");
        rf.addField(valOptArea);

        if (areas.length < 1) {
            $('.form-row.area').removeClass('select');
            $('.form-row.area label').empty().append(areaLabel);

        } else {
            $('.form-row.area').addClass('select');

            //submit value in formData
            if (areas.length === 1) {
                formData.area = areas[0].Name;
                rf.validate("area");
            }

            if (areas.length > 0) {
                //if City exists, submit the value in formData
                if (areas[0].City.length > 0 && $('input[name="city"]:text').length > 0) {
                    $('input[name="city"]:text').val(areas[0].City);
                    formData.city = areas[0].City;
                }

                //if Prefecture exists, submit the value in formData
                if (areas[0].Prefecture.Name.length > 0 && $('input[name="prefecture"]').length > 0) {
                    $('input[name="prefecture"]').val(areas[0].Prefecture.Name);
                    formData.prefecture = areas[0].Prefecture.Name;
                }
            }
            
        }

        //validate postal code
        if (areaAutoCompleteEnabled && areasCount > 1) {
            valOpts.postalCode.isValidPostalCode.config.areas = areas;
            rf.validate('postalCode');
        }   
    };

    form.resetAddressFields = function () {
        $('input[name="address"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");
        $('input[name="city"]', $form).val("");
        $('input[name="area"]', $form).val("");
        $('select[name="area"]', $form).val("");

        form.getAreasForPostCode();
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-generic-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="companyName"]', $form).val("");
        $('input[name="occupation"]', $form).val("");
        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="mobile"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('select[name="countryCode"]').val("");
        $('input[name="TermsOfUse"]', $form).prop('checked', false);

        form.resetAddressFields();
        rf.reset();
    };

    form.updatePostalCode = function (countryCode) {
        //delete validations related to country
        if (valOpts.postalCode && valOpts.postalCode.isValidPostalCode)
            delete valOpts.postalCode.isValidPostalCode;

        selectedCountry = $('.js-countries-selector option:selected', $form);
        areasCount = selectedCountry.length > 0 ? selectedCountry.data('areascount') : 0;

        //add validation
        if (areaAutoCompleteEnabled && areasCount > 1) {
            valOpts.postalCode = valOpts.postalCode || {};
            valOpts.postalCode = { ...valOpts.postalCode, ...{ isValidPostalCode: { validator: 'postalCode-invalid', config: { country: countryCode, areas: areas } } } };
        }

        //update validation field
        if (valOpts.postalCode) {
            var valOptPostalCode = { postalCode: valOpts.postalCode };
            rf.removeField("postalCode");
            rf.addField(valOptPostalCode);
        }
    };

    //init validation options
    var valOpts = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        valOpts[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        valOpts.email = valOpts.email || {};
        valOpts.email = { ...valOpts, ...{ isEmail: 'email-invalid' } };
    }

    //add mobile validation
    if ($('input[name="mobile"]', $form).length > 0) {
        valOpts.mobile = valOpts.mobile || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            valOpts.mobile = { ...valOpts.mobile, ...{ isValidPhoneLocalized: { validator: 'mobile-invalid', config: { type: 'mobile' } } } };
        } else {
            if (venddProjectConfigs.Account.RegexMobileValidation) {
                valOpts.mobile = { ...valOpts.mobile, ...{ isRegexMobile: { validator: 'mobile-invalid', config: { regex: venddProjectConfigs.Account.RegexMobileValue } } } };
            } else {
                valOpts.mobile = { ...valOpts.mobile, ...{ isPhoneNumber: 'mobile-invalid' } };
            }
        }
    }

    //add postalCode validation only if config parameter is true and selected country has areas
    if (areaAutoCompleteEnabled && areasCount > 1) {
        valOpts.postalCode = valOpts.postalCode || {};
        valOpts.postalCode = { ...valOpts.postalCode, ...{ isValidPostalCode: { validator: 'postalCode-invalid', config: { country: formData.countryCode, areas: areas } } } };
    }

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el);
        consentType.on('change', function () {
            rf.validate(consentType.attr('name'));
        });
    });

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox({
            touch: false,
            autoFocus: false
        });
    }

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        //update formData with latest values
        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"]), select', $form).each(function () {
            formData[$(this).attr('name')] = $(this).val();
        });

        var val1 = form.validateRecaptcha();
        var val2 = rf.validate();

        if (val1 && val2) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $form.closest('.fancybox-slide').animate({ scrollTop: $('.form-row.with-error', $form).first().offset().top - 100  }, 600);
            }
        }

        initialValidation = true;
    });

    form.checkConsents = function () {
        var data = [];
        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Registration Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    };

    $form.on('change', 'select[name]', function (e) {
        //update validation for postal code
        if ($(this).attr('name') === "countryCode") {

            var countryCode = $(this).val();

            if (countryCode === formData.countryCode) return;

            form.resetAddressFields();
            form.updatePostalCode(countryCode);
        }

        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        if ($(this).attr('name') === "postalCode") {
            removeWhiteSpaces($(this));
        }

        form.setField($(this));
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                rf.validateField("email");
            }
            if ($(this).attr('name') === "mobile") {
                rf.validateField("mobile");
            }
        } 

        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        formData[fieldName] = (fieldName === 'email') ? field.val().trim() : field.val();
        rf.validate(fieldName);
    };

    if (areaAutoCompleteEnabled) {
        $form.on('keyup', 'input[name="postalCode"]', $.debounce(400, function () {
            var $this = $(this);
            var postalCode = $this.val();
            isAuthenticated = false;

            if (postalCode.length > 0 && areasCount > 1)
                Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode(formData.countryCode, postalCode, ""));

            if (postalCode.length <= 0) {
                form.getAreasForPostCode(); 
            }

        }));

        $form.on('focus', 'input[name="area"]', function (e) {
            e.preventDefault();

            if (areasCount > 1)
                $('input[name="postalCode"]', $form).focus();
        });
    }

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="mobile"]', $form).length > 0) {
            $('input[name="mobile"]', $form).get(0).addEventListener("countrychange", function () {
                formData.mobile = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('mobile');
            });
        }
    }

    if (formData.postalCode.length > 0 && areasCount > 1) {
        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode(formData.countryCode, formData.postalCode, ""));
    }

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SubmitRequestOfferWidgetSuccess, form, form.onSuccess);

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SubmitRequestOfferWidgetFailure, form, form.onFailure);

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetAreasForPostCodeSuccess, form, form.getAreasForPostCode);

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, form, function (envelope) {
        wishlistModel = envelope.message.data;

        if (wishlistModel.IsEmpty) {
            $form.closest('.js-widget-container').hide();
        } else {
            $form.closest('.js-widget-container').show();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, form, function (envelope) {
        userData = envelope.message.data.model;

        if (userData.IsAuthenticated) {
            form.autofillFields();
            isAuthenticated = true;
        }
    });
  
});